const PASSWORD_CHANGE_REQUIRED_KEY = "passwordChangeRequired";
const SPOT_CHARTER_USING_KEY = "spotCharterUsingSign";

const saveBooleanSessionValue = (key, value) => {
  if (value === undefined || value === null) return;

  const normalizedValue =
    typeof value === "string" ? value.trim().toLowerCase() : value;

  localStorage.setItem(
    key,
    String(normalizedValue === true || normalizedValue === "true")
  );
};

export const isPasswordChangeRequired = () =>
  localStorage.getItem(PASSWORD_CHANGE_REQUIRED_KEY) === "true";

export const savePasswordChangeRequired = (value) => {
  const normalizedValue =
    typeof value === "string" ? value.trim().toLowerCase() : value;

  if (normalizedValue !== true && normalizedValue !== false &&
      normalizedValue !== "true" && normalizedValue !== "false") return;

  localStorage.setItem(
    PASSWORD_CHANGE_REQUIRED_KEY,
    String(normalizedValue === true || normalizedValue === "true")
  );
};

export const saveAuthSession = (userData, options = {}) => {
  const values = {
    userName: userData.username,
    accessToken: userData.access_token,
    role: userData.role,
    userId: userData.userId,
    guid: userData.guid,
    organization: userData.organization,
    organizationId: userData.organizationId,
    permissions: userData.permissions,
  };

  Object.keys(values).forEach((key) => {
    const value = values[key];
    if (value !== undefined && value !== null) {
      localStorage.setItem(key, value);
    }
  });

  const lang = (
    userData.language ||
    localStorage.getItem("lang") ||
    "en"
  ).toLowerCase();
  localStorage.setItem("lang", lang);

  if (userData.showNewDashboardSign !== undefined) {
    saveBooleanSessionValue(
      "showNewDashboardSign",
      userData.showNewDashboardSign
    );
  }

  saveBooleanSessionValue(
    SPOT_CHARTER_USING_KEY,
    userData.spotCharterUsingSign
  );

  savePasswordChangeRequired(userData.passwordChangeRequired);

  if (options.microsoft) {
    localStorage.setItem("loginMS", "true");
  }

  return {
    lang,
    passwordChangeRequired: isPasswordChangeRequired(),
  };
};

export const clearAuthSession = () => {
  [
    "userName",
    "accessToken",
    "role",
    "userId",
    "guid",
    "organization",
    "organizationId",
    "lang",
    "permissions",
    "showNewDashboardSign",
    SPOT_CHARTER_USING_KEY,
    "loginMS",
    PASSWORD_CHANGE_REQUIRED_KEY,
  ].forEach((key) => localStorage.removeItem(key));
};
